
export const professional = {
  style: {
    title: 'Estilo Profissional',
    subtitle: 'Sua abordagem ao trabalho e comunicação baseada em suas características principais'
  },
  workStyle: {
    title: 'Preferências de Estilo de Trabalho',
    steadyEnvironment: 'Prefere ambiente de trabalho estável e consistente',
    flexible: 'Adaptável e flexível',
    collaborative: 'Abordagem orientada para equipe e colaborativa',
    fastPaced: 'Abordagem dinâmica e acelerada',
    structured: 'Organizado e sistemático'
  },
  communication: {
    title: 'Estilo de Comunicação',
    conciseAndFocused: 'Comunicação concisa e focada',
    listensCarefully: 'Escuta cuidadosamente antes de responder',
    informalStyle: 'Abordagem informal e direta',
    enthusiastic: 'Estilo de comunicação entusiasmado e envolvente'
  }
};

export const workStyle = {
  title: 'Preferências de Estilo de Trabalho',
  fastPaced: 'Abordagem dinâmica e acelerada',
  collaborative: 'Orientado para equipe e colaborativo',
  structured: 'Organizado e sistemático',
  flexible: 'Adaptável e flexível',
  adaptable: 'Adaptável a vários ambientes de trabalho',
  balanced: 'Abordagem equilibrada aos desafios de trabalho',
  teamGoals: 'Abordagem estruturada para objetivos de equipe',
  teamInteraction: 'Interação regular da equipe e feedback',
  steadyEnvironment: 'Prefere ambiente de trabalho estável e consistente',
  supportiveRole: 'Papel de membro de equipe de apoio'
};

export const communication = {
  title: 'Estilo de Comunicação',
  balanced: 'Comunicação equilibrada e reflexiva',
  adaptive: 'Adapta estilo ao público e situação',
  direct: 'Comunicação clara e direta',
  supportive: 'Encorajador e solidário',
  informal: 'Abordagem informal e direta',
  diplomatic: 'Comunicação diplomática e estruturada',
  consensus: 'Construindo consenso através de discussão',
  enthusiastic: 'Estilo entusiasmado e envolvente',
  conciseAndFocused: 'Comunicação concisa e focada',
  listensCarefully: 'Escuta cuidadosamente antes de responder',
  informalStyle: 'Abordagem informal e direta'
};
